import { Configuration, LogLevel } from '@azure/msal-browser';

// Azure AD environment variables - not logged to console for security

// Check if Azure AD is enabled - read from environment variable
export const isAzureADEnabled = process.env.REACT_APP_AZURE_AD_ENABLED === 'true';

// Get base URLs from environment
const AZURE_LOGIN_BASE_URL = process.env.REACT_APP_AZURE_LOGIN_BASE_URL || 'https://login.microsoftonline.com';
const GRAPH_API_BASE_URL = process.env.REACT_APP_GRAPH_API_BASE_URL || 'https://graph.microsoft.com';

// Get Azure AD configuration from environment
// IMPORTANT: These values MUST be set via environment variables during build
// No hardcoded fallbacks for security - application will fail if not properly configured
const AZURE_CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const AZURE_TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || '';

// Azure Client ID and Tenant ID - not logged to console for security

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    authority: `${AZURE_LOGIN_BASE_URL}/${AZURE_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_AZURE_POST_LOGOUT_URI || window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Use sessionStorage for better security
    storeAuthStateInCookie: false, // Set to true for IE11 compatibility
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        // Only log errors in production, suppress info/verbose/warning logs
        // MSAL logs are disabled to prevent console clutter and potential security concerns
        if (level === LogLevel.Error) {
          console.error(message);
        }
        // All other log levels (Info, Verbose, Warning) are suppressed
      },
      logLevel: LogLevel.Error, // Set minimum log level to Error only
    },
  },
};

// Add scopes for Microsoft Graph API
export const loginRequest = {
  scopes: ['User.Read', 'profile', 'openid', 'email'],
};

// Add scopes for silent token acquisition
export const silentRequest = {
  scopes: ['User.Read'],
  account: null as any,
};

// Graph API endpoint
export const graphConfig = {
  graphMeEndpoint: `${GRAPH_API_BASE_URL}/v1.0/me`,
  graphUsersEndpoint: `${GRAPH_API_BASE_URL}/v1.0/users`,
};

// Validate configuration
export const validateAzureConfig = (): boolean => {
  if (!isAzureADEnabled) {
    return true; // Skip validation if Azure AD is disabled
  }

  const required = [
    'REACT_APP_AZURE_CLIENT_ID',
    'REACT_APP_AZURE_TENANT_ID',
  ];

  const missing = required.filter(key => !process.env[key]);

  if (missing.length > 0) {
    // Missing Azure AD environment variables - error not logged for security
    return false;
  }

  return true;
};